import styled from 'styled-components';

export const StyledAlertHistoryBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;

  .main-desc {
    width: 100%;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

export const StyledUserInfoBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 360px;
  height: 102px;
  border-radius: 6px;
  background: #fff3eb;
  padding: 10px;

  .image-box {
    display: flex;
    align-items: center;
    gap: 12px;

    &-img {
      width: 62px;
      height: 62px;
      border-radius: 50%;
      background-color: #ffffff;
      overflow: hidden;

      > img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .user-box {
      display: flex;
      flex-direction: column;
      gap: 2px;

      > h2 {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }

      > p {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }

  .device-info-box {
    border-radius: 4px;
    border: 0.5px solid var(--color-pale-gray);
    background: #ffffff;
    padding: 7px;

    .title {
      color: var(--color-white);
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      > img {
        width: 28px;
        height: 28px;
        object-fit: contain;
      }

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -5px;
        transform: translateX(-50%);
        width: 62px;
        height: 1px;
        background-color: var(--color-pale-gray);
      }
    }

    .desc {
      margin-top: 14px;
      color: #ff6a0d;
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;

      > span {
        display: inline-block;
        color: #ff6a0d;
        text-align: center;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
`;
